import { Box, BoxList, Tag, Text } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import i18n from 'modules/core/lib/i18n'

import { WorkSpaceNode } from 'modules/space_control/hooks/useWorkSpaces'

import Options from './Options'

interface PropsWorkArea {
  workSpace: WorkSpaceNode
  locationId: string
  workAreaId: string
  isHighlighted?: boolean
  onSelect?: (ws: WorkSpaceNode) => void
  canEditSpace: boolean
  canDeleteSpace: boolean
  onDeleteSuccess: () => void
}

const WorkSpaceItem = ({
  workSpace,
  locationId,
  workAreaId,
  isHighlighted = false,
  onSelect,
  canEditSpace,
  canDeleteSpace,
  onDeleteSuccess,
}: PropsWorkArea) => {
  const handleClick = () => {
    if (onSelect) {
      onSelect(workSpace)
    }
  }

  return (
    <Box
      onClick={handleClick}
      cursor="pointer"
      background={isHighlighted ? 'grey100' : 'transparent'}
      border={{
        all: { color: isHighlighted ? 'viridian100' : 'grey100', width: 's2', style: 'solid' },
      }}
      borderRadius={isHighlighted ? { all: 'abs004' } : undefined}
    >
      <BoxList.Item key={workSpace.id} className="p-3">
        <Box width="s96">
          <Text.Normal ellipsis size="300" weight="medium" color="grey1000">
            {workSpace.name}
          </Text.Normal>
          <Text.Normal size="200" weight="normal" color="grey800">
            {i18n.tp('settings.locations.location.work_spaces.capacity_count', {
              count: workSpace.capacity,
            })}
          </Text.Normal>
        </Box>
        <Box flexDirection="row" justifyContent="spaceAround" gap="s12">
          <Box alignItems="center" justifyContent="center">
            <Tag type="grey">{workSpace.workSpaceTypeName}</Tag>
          </Box>
          <Options
            locationId={locationId}
            workAreaId={workAreaId}
            workSpace={workSpace}
            canEditSpace={canEditSpace}
            canDeleteSpace={canDeleteSpace}
            onDeleteSuccess={onDeleteSuccess}
          />
        </Box>
      </BoxList.Item>
    </Box>
  )
}

export default observer(WorkSpaceItem)
